import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as ReportGenerationStore from '../../../../../redux/reportGeneration';
import useReportContainer from '../context/useReportContainer';
import ReportPreview from '../shared/components/Preview';
import type {
  ProjectContext,
  ReportCategory,
  ReportExclusionOptions,
  ReportGenerationParams,
} from '../../shared/types';
import type {
  DependencyMetadataFilterOption,
  FormatName,
  IncludeFilterOption,
  IncludeFixPlanFilterOption,
} from '../shared/types';

import { getPreviewURL } from './utils';

type Props = {
  params: ReportGenerationParams;
  format: FormatName | null;
  includeOptions: IncludeFilterOption[];
  dependencyMetadataOptions: DependencyMetadataFilterOption[];
  excludeOptions: ReportExclusionOptions;
  fixPlanOptions: IncludeFixPlanFilterOption[];
  authorName?: string;
  authorEmail?: string;
  supplier?: string;
};

const Preview: VoidFunctionComponent<Props> = ({
  params: { report_type: reportType },
  format,
  includeOptions,
  dependencyMetadataOptions,
  excludeOptions,
  fixPlanOptions,
  authorName,
  authorEmail,
  supplier,
}: Props) => {
  const reportContext = useSelector(ReportGenerationStore.selectors.getReportContext) as ProjectContext;
  const { useReportsV2Toggle } = useReportContainer();
  const url = getPreviewURL({
    projectRevisionLocator: reportContext.revision,
    reportType,
    format,
    includeOptions,
    dependencyMetadataOptions,
    fixPlanOptions,
    authorName,
    authorEmail,
    supplier,
    excludeOptions,
    useReportsV2: useReportsV2Toggle,
  });

  return (
    <ReportPreview
      previewURL={url}
      reportType={reportType as ReportCategory}
      format={format}
      includeOptions={includeOptions}
      dependencyMetadataOptions={dependencyMetadataOptions}
    />
  );
};

export default Preview;
